// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3JHzC1f-osiFkl {\n  color: #5E6C84;\n  display: block;\n  font-size: 12px;\n  line-height: 10px;\n  margin: 0;\n  padding: 0;\n}\n._3YD6SJ5TQfxM1c {\n  font-size: 12px;\n  padding: 0;\n  margin: 0;\n  color: #5E6C84;\n  text-decoration: underline;\n  background-color: transparent;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "_3JHzC1f-osiFkl",
	"upgradeButton": "_3YD6SJ5TQfxM1c"
};
export default ___CSS_LOADER_EXPORT___;
